import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultConfig = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    pauseOnFocusLoss: false,
};

export const showSuccess = (message, options = {}) => {
    toast.success(message, { ...defaultConfig, ...options });
};

export const showError = (message, options = {}) => {
    toast.error(message, { ...defaultConfig, ...options });
};

export const showInfo = (message, options = {}) => {
    toast.info(message, { ...defaultConfig, ...options });
};

export const showWarning = (message, options = {}) => {
    toast.warning(message, { ...defaultConfig, ...options });
};

export const showSuccessLong = (message, options = {}) => {
    toast.success(message, { ...defaultConfig, autoClose: 5000, ...options });
};

export const showErrorLong = (message, options = {}) => {
    toast.error(message, { ...defaultConfig, autoClose: 5000, ...options });
};

export const showInfoLong = (message, options = {}) => {
    toast.info(message, { ...defaultConfig, autoClose: 5000, ...options });
};

export const showWarningLong = (message, options = {}) => {
    toast.warning(message, { ...defaultConfig, autoClose: 5000, ...options });
};

const toastUtils = {
    success: showSuccess,
    error: showError,
    info: showInfo,
    warning: showWarning,
    successLong: showSuccessLong,
    errorLong: showErrorLong,
    infoLong: showInfoLong,
    warningLong: showWarningLong,
};

export default toastUtils;